// extracted by mini-css-extract-plugin
export default {"extraSmall":"Logo_extraSmall__nKX5T","small":"Logo_small__lYzil","medium":"Logo_medium__tU5fW","big":"Logo_big__ptaaO"};